import { useState, useEffect } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import LinkConverter from "./components/LinkConverter";
import CategoryGrid from "./components/CategoryGrid";
import Footer from "./components/Footer";

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [sharedUrl, setSharedUrl] = useState("");

  useEffect(() => {
    // Check for shared URL from Web Share Target or query params
    const params = new URLSearchParams(window.location.search);
    const url = params.get("url") || params.get("text") || "";
    if (url) {
      const urlMatch = url.match(/https?:\/\/[^\s]+/);
      if (urlMatch) {
        setSharedUrl(urlMatch[0]);
      }
      // Clean URL
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, []);

  const toggleDarkMode = () => setDarkMode(!darkMode);

  return (
    <div className={`min-h-screen ${darkMode ? "dark" : ""}`}>
      <div className="min-h-screen bg-gray-50 dark:bg-amazon-dark transition-colors duration-300">
        <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
        <main>
          <Hero />
          <LinkConverter initialUrl={sharedUrl} />
          <CategoryGrid />
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;
